import Model, { toProp, toMoment } from "./Model";

/**
 *
 * @class SDMEncounter
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/model/SDMEncounter.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class SDMEncounter extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    /** @type Moment */
    this.encounterDate = toMoment()

    /** @type string */
    this.status = toProp()

    /** @type string */
    this.version = toProp()

    this.buildModel(modelData)
  }
}

export default SDMEncounter